import { Card, Stack, Typography, Grid } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import Page from "../components/Page";
import { ListadoReportes } from "../sections/@reporteador";
import ReportePorDia from "../sections/@reporteador/ReportesPorDia";
const Reportes = () => {
  const [datos, setDatos] = useState([]);
  const [title, setTitle] = useState("");
  return (
    <>
      <Page title="Reporteador">
        <Container maxWidth="xl">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Reporteador
            </Typography>
          </Stack>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <ListadoReportes setDatos={setDatos} />
              </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <ReportePorDia datos={datos} leyendas={title}/>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Page>
    </>
  );
};

export default Reportes;
